import "./contact.css";
import { GrMail } from "react-icons/gr";
import { FaPhone, FaAddressCard } from "react-icons/fa";
import { FcLike } from "react-icons/fc";
import { SiGithub, SiLinkedin, SiMedium, SiFacebook } from "react-icons/si";
import { ImLocation } from "react-icons/im";
import axios from "axios";
import { useState } from "react";
import swal from "sweetalert";
import GitHubIcon from "@material-ui/icons/GitHub";

export const Contact = () => {
  const goMedium = () => {
    window.open("https://medium.com/@neha712513", "_blank");
  };

  const goLinkedin = () => {
    window.open("https://www.linkedin.com/in/2510-neha-sen/", "_blank");
  };

  const goFacebook = () => {
    window.open(
      "https://www.facebook.com/profile.php?id=100079466264331",
      "_blank"
    );
  };

  const goGithub = () => {
    window.open("https://github.com/Neha-251", "_blank");
  };

  const goLocation = () => {
    window.open(
      "https://www.google.com/maps/place/Chinsurah,+West+Bengal/@22.9027412,88.3547135,13z/data=!3m1!4b1!4m5!3m4!1s0x39f893dbd4300835:0xeaaf1f3b1143711d!8m2!3d22.9011588!4d88.3898552",
      "_blank"
    );
  };

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    let { className, value } = e.target;
    setFormData({ ...formData, [className]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post("https://portfolio-neha-sen.herokuapp.com/users", formData)
      .then(({ data }) => {
        setFormData(formData);
      });

    swal({
      title: "Hey There!",
      text: "Thanks for Putting a Message",
      button: "OK",
      //icon: "success"
    });
  };

  return (
    <>
      <div className="aboutContainer" id="contact">
        <div className="headingBtn">
          <p className="heading">Contact</p>
          <div></div>
        </div>

        <div className="contactMainDiv">
          <div>
            <GrMail data-aos="slide-up" className="contact_icon" />
            <p>nehasen2510@gmail.com</p>
          </div>
          <div>
            <FaPhone data-aos="slide-up" className="contact_icon" />
            <p>+91 9433906191</p>
          </div>
          <div>
            <FaAddressCard data-aos="slide-up" className="contact_icon" />
            <p>Chinsurah, Hooghly, West Bengal</p>
            <ImLocation
              className="contact_icon"
              style={{ cursor: "pointer" }}
              onClick={goLocation}
            />
          </div>

          <div className="contact_iconDiv">
            <SiGithub
              data-aos="slide-down"
              className="contact_icon2"
              onClick={goGithub}
            />
            <SiLinkedin
              data-aos="slide-down"
              className="contact_icon2"
              onClick={goLinkedin}
            />
            <SiMedium
              data-aos="slide-down"
              className="contact_icon2"
              onClick={goMedium}
            />
            <SiFacebook
              data-aos="slide-down"
              className="contact_icon2"
              onClick={goFacebook}
            />
          </div>
        </div>
      </div>

      {/* <div className="message_container">
                <form className="form" onSubmit={handleSubmit}>
                    <input type="text" className="first_name" value={formData.first_name} onChange={(e) => { handleChange(e) }} placeholder="First Name" />
                    <input type="text" className="last_name" value={formData.last_name} onChange={(e) => { handleChange(e) }} placeholder="Last Name" />
                    <input type="text" className="email" value={formData.email} onChange={(e) => { handleChange(e) }} placeholder="Email" />
                    <input type="text" className="subject" value={formData.subject} onChange={(e) => { handleChange(e) }} placeholder="Subject" />
                   
                    <textarea name="message" className="message" value={formData.message} onChange={(e) => { handleChange(e) }} placeholder="Message..." cols="10" rows="10"></textarea>
                    <input type="submit" className="submitBtn"/>

                </form>
            </div> */}

      <div className="lastP">
        <h6>
          Made with <FcLike className="loveIcon" /> by Neha
        </h6>
      </div>
    </>
  );
};
